export const categories = [
  {
    id: "cat-1",
    name: "网红黑料",
    slug: "influencer",
    description: "追踪各大平台网红主播的塌房现场、反差视频与争议事件",
    icon: "ri-user-star-line",
    articleCount: 128,
  },
  {
    id: "cat-2",
    name: "明星爆料",
    slug: "celebrity",
    description: "娱乐圈明星的独家爆料、恋情揭秘与负面新闻追踪",
    icon: "ri-vip-crown-line",
    articleCount: 96,
  },
  {
    id: "cat-3",
    name: "独家内幕",
    slug: "exclusive",
    description: "第一手独家猛料，深度调查报道与内幕揭秘",
    icon: "ri-eye-line",
    articleCount: 64,
  },
  {
    id: "cat-4",
    name: "每日大赛",
    slug: "daily",
    description: "每日精选最劲爆的爆料大赛，吃瓜群众投票评选",
    icon: "ri-trophy-line",
    articleCount: 42,
  },
  {
    id: "cat-5",
    name: "社会热点",
    slug: "society",
    description: "社会事件、民生爆料与热点追踪报道",
    icon: "ri-fire-line",
    articleCount: 85,
  },
  {
    id: "cat-6",
    name: "财经揭秘",
    slug: "finance",
    description: "财经圈、投资领域的黑幕曝光与风险警示",
    icon: "ri-money-cny-circle-line",
    articleCount: 37,
  },
];